// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1lVgh","title":"AfterFrontImage_title__3U3jf"};